export const engagementCampaignsGlobalFrequencyCapsAppGroupId =
  "/engagement/campaigns/global_frequency_caps/:app_group_id";
